import moment from "moment"
import { set } from "lodash"

function initMoment() {
  moment.updateLocale("en", {
    weekdaysMin: ["S", "M", "T", "W", "T", "F", "S"],
    calendar: {
      lastDay: "[Yesterday]",
      sameDay: "[Today]",
      nextDay: "[Tomorrow]",
      lastWeek: "[last] dddd",
      nextWeek: "MMM D",
      sameElse: "MMM D",
    },
  })
}

function initSegment(key) {
  const analytics = window.analytics = window.analytics || []
  if (analytics.initialize) return
  if (analytics.invoked) {
    if (window.console && console.error) {
      console.error("Segment snippet included twice.")
    }
    return
  }
  analytics.invoked = true
  analytics.methods = [
    "trackSubmit",
    "trackClick",
    "trackLink",
    "trackForm",
    "pageview",
    "identify",
    "reset",
    "group",
    "track",
    "ready",
    "alias",
    "debug",
    "page",
    "once",
    "off",
    "on",
    "addSourceMiddleware",
    "addIntegrationMiddleware",
    "setAnonymousId",
    "addDestinationMiddleware",
  ]
  analytics.factory = function (method) {
    return function () {
      const args = Array.prototype.slice.call(arguments)
      args.unshift(method)
      analytics.push(args)
      return analytics
    }
  }
  for (let i = 0; i < analytics.methods.length; i++) {
    const key = analytics.methods[i]
    analytics[key] = analytics.factory(key)
  }
  analytics.load = function (key) {
    const script = document.createElement("script")
    script.type = "text/javascript"
    script.async = true
    script.src = `https://cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`
    const first = document.getElementsByTagName("script")[0]
    first.parentNode.insertBefore(script, first)
  }

  analytics._writeKey = key
  analytics.SNIPPET_VERSION = "4.15.2"
  analytics.load(key)
  analytics.page()
}

function initSentry(url) {
  if (process.env.NODE_ENV === "production") {
    const { init, captureException } = require("@sentry/browser")
    init({ dsn: url })
    // Used to be able to test sentry from dev tools.
    window.captureException = captureException
  }
}

function initCaptcha(siteKey) {
  set(window, "captcha.siteKey", siteKey)
}

export default function (sentryUrl, segmentKey, captchaKey) {
  initSentry(sentryUrl)
  initSegment(segmentKey)
  initMoment()
  initCaptcha(captchaKey)
}
